var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c("div", { staticClass: "popup", attrs: { id: "freeSaledPopup" } }, [
        _vm.type == 1
          ? _c(
              "div",
              { staticClass: "freesale-content freesale-content-default" },
              [
                _c("div", {
                  staticClass: "default-close freesale-close",
                  on: {
                    click: function($event) {
                      return _vm.saveTag(0)
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "freesale-body" }, [
                  _c("div", { staticStyle: { height: "228px" } }),
                  _vm._v(" "),
                  _c("div", { staticClass: "freesale-tips" }, [
                    _vm._v(
                      _vm._s(_vm.$t("language.popup.freeSaledPopup.tips1"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "freesale-btns" }, [
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.isLoading == 2,
                            expression: "isLoading==2"
                          }
                        ],
                        on: {
                          click: function($event) {
                            return _vm.saveTag(1)
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("language.popup.freeSaledPopup.btns1"))
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            _vm.type = 2
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("language.popup.freeSaledPopup.btns2"))
                        )
                      ]
                    )
                  ])
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.type == 2
          ? _c(
              "div",
              { staticClass: "freesale-content freesale-content-wait" },
              [
                _c("div", {
                  staticClass: "default-close freesale-close",
                  on: {
                    click: function($event) {
                      return _vm.saveTag(0)
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "freesale-body" }, [
                  _c("div", { staticClass: "freesale-title" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../assets/images/saleActive/doubt-emoji.svg")
                      }
                    }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("language.popup.freeSaledPopup.tips2"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "freesale-tips" }, [
                    _vm._v(
                      _vm._s(_vm.$t("language.popup.freeSaledPopup.tips3"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "freesale-btns" }, [
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.isLoading == 2,
                            expression: "isLoading==2"
                          }
                        ],
                        on: {
                          click: function($event) {
                            return _vm.saveTag(1)
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("language.popup.freeSaledPopup.btns1"))
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.isLoading == 3,
                            expression: "isLoading==3"
                          }
                        ],
                        staticClass: "transparent-button",
                        on: {
                          click: function($event) {
                            return _vm.saveTag(2)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("language.common.skip")))]
                    )
                  ])
                ])
              ]
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ad46e79", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ad46e79","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/upgrade_popups/free_saled_popup.vue
// module id = null
// module chunks = 